import React from "react";
import { Button } from "antd";
import { EComModal } from "../../../../../components/EComModal";

interface SaveOfferHeadsUpModalProps {
  headsUpModalVisible: boolean;
  setHeadsUpModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export function SaveOfferHeadsUpModal({ headsUpModalVisible, setHeadsUpModalVisible }: SaveOfferHeadsUpModalProps) {
  return (
    <EComModal
      visible={headsUpModalVisible}
      title="Heads up"
      onCancel={() => setHeadsUpModalVisible(false)}
      footer={[
        <Button
          key="back"
          type="primary"
          shape="round"
          style={{ minWidth: "92px" }}
          onClick={() => setHeadsUpModalVisible(false)}
        >
          Got It
        </Button>,
      ]}
    >
      <div>
        If the subscription you’re switching from and the one you’re switching to have the{" "}
        <b>same base price and billing plan</b>, the Save Offer <b>won’t be triggered</b> during cancellation.
      </div>
    </EComModal>
  );
}
